import React from 'react';
import NewBMStep5 from './NewBMStep5';

const NewVMStep5Container = ({ formikProp }) => {
  return <NewBMStep5 formikProp={formikProp} />;
};
export default NewVMStep5Container;